import EventoActionTypes from "./action-types.ts";

export const eventoState = (payload) => ({
    type: EventoActionTypes.ACAO_EVENTO,
    payload,
});